import { render } from "./MilesNBonusRibbon.vue?vue&type=template&id=342341f2"
import script from "./MilesNBonusRibbon.vue?vue&type=script&setup=true&lang=js"
export * from "./MilesNBonusRibbon.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/MilesNBonusRibbon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "342341f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('342341f2', __exports__)) {
    api.reload('342341f2', __exports__)
  }
  
  module.hot.accept("./MilesNBonusRibbon.vue?vue&type=template&id=342341f2", () => {
    api.rerender('342341f2', render)
  })

}


export default __exports__